export enum SkillType {
  BOOK_APPOINTMENT = 'book_appointment',
  DISPATCH_ON_PHRASE = 'dispatch_on_phrase',
  CALL_BACK_LATER = 'call_back_later',
  ECOMMERCE_SHOPPING = 'ecommerce_shopping',
  KNOWLEDGE_SEARCH = 'knowledge_search',
  SWITCH_COMMUNICATION = 'switch_communication',
}

export const REQUIRED_AGENT_CONFIG_FOR_SKILLS = [
  {
    type: SkillType.BOOK_APPOINTMENT,
    config: {
      enable_mcp: true,
    },
  },
  {
    type: SkillType.DISPATCH_ON_PHRASE,
    config: {
      enable_mcp: true,
    },
  },
];

export const SKILL_OPTIONS = [
  {
    type: SkillType.BOOK_APPOINTMENT,
    name: 'Appointment Scheduling',
    tooltip: 'Schedule appointments with your customers',
  },
  {
    type: SkillType.DISPATCH_ON_PHRASE,
    name: 'Call Routing',
    tooltip: 'Transfer to a human based on a certain phrase',
  },
  {
    type: SkillType.CALL_BACK_LATER,
    name: 'Call Back Later',
    tooltip:
      'Automatically calls your customer back if they’re unavailable right now.',
  },
  {
    type: SkillType.KNOWLEDGE_SEARCH,
    name: 'Knowledge Search',
    tooltip: 'Search your knowledge base for information.',
  },
  {
    type: SkillType.SWITCH_COMMUNICATION,
    name: 'Switch Communication',
    tooltip: 'Allow switching to a different communication channel',
  },
];

export type CallBackLaterConfig = {
  callback_initial_message?: string;
  end_call_message?: string;
};

export const INITIAL_CALL_TIME_CONFIRMATION_MESSAGE =
  "Great. We'll call you back at that time. Goodbye.";

const INITIAL_CALL_BACK_LATER_CONFIG: CallBackLaterConfig = {
  end_call_message: INITIAL_CALL_TIME_CONFIRMATION_MESSAGE,
};

export const SKILL_DEFAULT_CONFIG: Record<string, object> = {
  [SkillType.CALL_BACK_LATER]: INITIAL_CALL_BACK_LATER_CONFIG,
};
